<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">推廣碼管理</h1>
        <p class="page-subtitle">查看、編輯和新增推廣優惠碼</p>
      </div>
      <div class="header-right">
        <el-button size="mini" type="warning" @click="onAdd" icon="el-icon-plus">
          新增推廣碼
        </el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              :data="promotionCodes"
              style="width: 100%;"
              border
              stripe
              size="small"
              :empty-text="promotionCodes.length === 0 ? '暫無推廣碼數據' : ''"
          >
            <el-table-column type="index" width="60" label="#"></el-table-column>
            <el-table-column
                prop="code"
                label="推廣碼"
                align="center"
                min-width="120"
            >
              <template slot-scope="{ row }">
                <el-tag type="info" size="mini" class="code-tag">
                  {{ row.code }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                prop="description"
                label="描述"
                align="center"
                min-width="200"
            >
              <template slot-scope="{ row }">
                <span>{{ row.description || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="discount"
                label="折扣"
                align="center"
                width="100"
            >
              <template slot-scope="{ row }">
                <!-- PC端折扣标签 - 添加白色文字 -->
                <el-tag
                    type="success"
                    size="mini"
                    :style="{
                    backgroundColor: getDiscountColor(row.discount),
                    color: '#fff',
                    borderColor: 'transparent'
                  }"
                >
                  {{ row.discount }}%
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="{ row }">
                <el-button
                    type="text"
                    size="small"
                    @click="onDetailButton(row.id)"
                    icon="el-icon-view"
                >
                  詳情
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    @click="onEditButton(row.id)"
                    icon="el-icon-edit"
                >
                  編輯
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="promotion-card" v-for="(item, index) in promotionCodes" :key="item.id || index">
            <!-- 卡片头部：推广码 + 折扣 -->
            <div class="card-header">
              <div class="code-wrapper">
                <span class="code-label">推廣碼：</span>
                <el-tag type="info" size="mini" class="code-tag">
                  {{ item.code }}
                </el-tag>
              </div>
              <!-- 移动端折扣标签 - 添加白色文字 -->
              <el-tag
                  type="success"
                  size="mini"
                  :style="{
                  backgroundColor: getDiscountColor(item.discount),
                  color: '#fff',
                  borderColor: 'transparent'
                }"
                  class="discount-tag"
              >
                {{ item.discount }}% 折扣
              </el-tag>
            </div>

            <!-- 卡片主体：描述 -->
            <div class="card-body">
              <div class="desc-label">描述：</div>
              <div class="desc-content">{{ item.description || '無描述信息' }}</div>
            </div>

            <!-- 卡片操作栏 -->
            <div class="card-actions">
              <el-button
                  type="text"
                  size="mini"
                  @click="onDetailButton(item.id)"
                  icon="el-icon-view"
              >詳情</el-button>
              <el-button
                  type="text"
                  size="mini"
                  @click="onEditButton(item.id)"
                  icon="el-icon-edit"
              >編輯</el-button>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="promotionCodes.length === 0">
            <i class="el-icon-coupon"></i>
            <p>暫無推廣碼數據</p>
            <el-button type="warning" size="small" @click="onAdd" icon="el-icon-plus">
              立即新增
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPromotionCodes, addPromotionCodes, putPromotionCodes, getPromotionCodesDetail } from '@/api/order'

export default {
  data() {
    return {
      promotionCodes: [],
      isEdit: false,
      programmeId: null,
      formLabelAlign: {
        name: "",
        image: null,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      rules: {
        name: { required: true, message: "", trigger: "change" },
      },
    };
  },
  created() {
    this.getPromotionCodes();
  },
  methods: {
    // 根据折扣值获取对应颜色
    getDiscountColor(discount) {
      const discountNum = Number(discount) || 0;
      if (discountNum >= 30) return '#e64340';    // 高折扣-红色
      if (discountNum >= 20) return '#f7ba1e';    // 中折扣-黄色
      if (discountNum >= 10) return '#409eff';    // 低折扣-蓝色
      return '#67c23a';                           // 普通折扣-绿色
    },
    // 路由跳转方法补充
    resolveRouter(path) {
      this.$router.push(path);
    },
    // 编辑推广码
    onEditButton(id) {
      let path = `/promote/${id}/edit`;
      this.resolveRouter(path);
    },
    // 查看推广码详情
    onDetailButton(id) {
      let path = `/promote/${id}`;
      this.resolveRouter(path);
    },
    // 新增推广码
    onAdd() {
      let path = `/promote/add`;
      this.resolveRouter(path);
    },
    // 对话框确认
    onDialogConfirmFunction() {
      this.$refs.ruleForm?.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.putPromotionCodes();
          } else {
            this.addPromotionCodes();
          }
        } else {
          return false;
        }
      });
    },
    // 子组件传值处理
    childByValue(v) {
      this.formLabelAlign.image = v;
      this.addPromotionCodes();
    },
    // 对话框取消
    onDialogCancelButton() {
      this.dialogSlotVisible = false;
    },
    // 取消按钮
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    // 删除按钮（预留）
    onDeleteButton(id) {
      this.programmeId = id;
      this.centerDialogVisible = true;
    },
    // 获取推广码列表
    getPromotionCodes() {
      getPromotionCodes()
          .then((v) => {
            this.promotionCodes = v.data || [];
          })
          .catch(err => {
            this.$message.error("獲取推廣碼列表失敗，請稍後重試");
            console.error('获取推广码失败：', err);
            this.promotionCodes = [];
          });
    },
    // 添加推广码
    addPromotionCodes() {
      addPromotionCodes(this.formLabelAlign)
          .then(() => {
            this.$message.success("新增推廣碼成功");
            this.getPromotionCodes();
          })
          .catch(err => {
            this.$message.error("新增推廣碼失敗，請稍後重試");
            console.error('新增推广码失败：', err);
          })
          .finally(() => {
            this.dialogSlotVisible = false;
          });
    },
    // 获取推广码详情
    getPromotionCodesDetail() {
      getPromotionCodesDetail(this.programmeId)
          .then((v) => {
            this.formLabelAlign = v.data || {};
            this.dialogSlotVisible = true;
          })
          .catch(err => {
            this.$message.error("獲取推廣碼詳情失敗，請稍後重試");
            console.error('获取推广码详情失败：', err);
          });
    },
    // 修改推广码
    putPromotionCodes() {
      putPromotionCodes(this.programmeId, this.formLabelAlign)
          .then(() => {
            this.$message.success("修改推廣碼成功");
            this.getPromotionCodes();
          })
          .catch(err => {
            this.$message.error("修改推廣碼失敗，請稍後重試");
            console.error('修改推广码失败：', err);
          })
          .finally(() => {
            this.dialogSlotVisible = false;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 数据容器样式 */
.data-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      .code-tag {
        font-weight: 600;
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 推广码卡片 */
    .promotion-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;
      transition: all 0.2s ease;

      &:hover {
        border-color: #166ea5;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }

      /* 卡片头部 */
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dee2e6;

        .code-wrapper {
          display: flex;
          align-items: center;
          gap: 6px;
          flex: 1;

          .code-label {
            font-size: 12px;
            color: #6c757d;
            white-space: nowrap;
          }

          .code-tag {
            font-weight: 600;
          }
        }

        .discount-tag {
          flex-shrink: 0;
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 12px;

        .desc-label {
          font-size: 12px;
          color: #6c757d;
          margin-bottom: 4px;
        }

        .desc-content {
          font-size: 14px;
          color: #1f2937;
          line-height: 1.4;
          word-break: break-all;
        }
      }

      /* 卡片操作栏 */
      .card-actions {
        display: flex;
        gap: 12px;
        padding-top: 12px;
        border-top: 1px solid #f1f3f5;

        .el-button {
          font-size: 12px;
          padding: 4px 8px;
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0 0 20px 0;
      }
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }

  .data-container .mobile-cards {
    display: flex;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .layout {
    padding: 20px;
  }
}
</style>